import { render, staticRenderFns } from "./AddBannerImage.vue?vue&type=template&id=22913cc5&scoped=true"
import script from "./AddBannerImage.vue?vue&type=script&lang=js"
export * from "./AddBannerImage.vue?vue&type=script&lang=js"
import style0 from "./AddBannerImage.vue?vue&type=style&index=0&id=22913cc5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22913cc5",
  null
  
)

export default component.exports